import type { FunctionComponent } from 'react'

import { FlowPage } from '@monthio/design-system'
import { LanguageContext, trackingService } from '@monthio/react-components'
import config from '#config'
import { useContext, useEffect } from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'

import type { RootState } from '../../store/reducers'

import { getLanguageFromRegion } from '../../components/InitialFlowLanguageSetter/InitialFlowLanguageSetter'
import { GenericLandingPageContent } from './GenericLandingPageContent'

const PageWrapper = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
`

interface GenericLandingPageProps {
	consumerInputsStepIndex?: number
	children?: never
}

export const GenericLandingPage: FunctionComponent<GenericLandingPageProps> = ({
	consumerInputsStepIndex,
}) => {
	const { updateLanguage, language } = useContext(LanguageContext)
	const subdomainInfo = useSelector(
		(state: RootState) => state.flowEntryStatemachine.whitelabelSubdomainInfo,
	)

	const region = subdomainInfo != null ? subdomainInfo.region : undefined

	useEffect(() => {
		if (config.initialLanguageDetected || language === 'cimode') {
			return
		}
		updateLanguage(getLanguageFromRegion(region))
	}, [region])

	if (subdomainInfo == null) {
		return (
			<PageWrapper>
				<FlowPage>
					<FlowPage.Content $isCentered>
						<FlowPage.Header title="404" description="Page not found" />
					</FlowPage.Content>
				</FlowPage>
			</PageWrapper>
		)
	}

	useEffect(() => {
		trackingService.trackEvent('Started genericLandingPage', {
			clientName: subdomainInfo?.clientName,
		})
	}, [])

	return (
		<PageWrapper>
			<GenericLandingPageContent
				subdomainInfo={subdomainInfo}
				consumerInputsStepIndex={consumerInputsStepIndex}
			/>
		</PageWrapper>
	)
}
